(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clinical-results"] && !Shopify.designMode) return;
  try {
    
/* intentionally empty: no custom JS needed after removing horizontal scroll */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-home-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-dtc-product-showcase]';
    const instances = new WeakMap();

    function findRoot(target) {
      if (!target) return null;
      if (target.matches && target.matches(rootSelector)) return target;
      return target.querySelector ? target.querySelector(rootSelector) : null;
    }

    function initializeProductShowcase(root) {
      if (!root || instances.has(root)) return;

      const track = root.querySelector('[data-dtc-product-track]');
      const categoryTrack = root.querySelector('[data-dtc-product-categories]');
      const cards = Array.from(root.querySelectorAll('[data-dtc-product-card]'));
      const categories = Array.from(root.querySelectorAll('[data-dtc-product-category]'));
      const desktopHover = window.matchMedia('(min-width: 1280px) and (hover: hover) and (pointer: fine)');
      const desktopSlider = window.matchMedia('(min-width: 1280px)');
      const mobileSlider = window.matchMedia('(max-width: 749px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const sliderEnabled = root.dataset.desktopSliderEnabled === 'true';

      if (!track || !categoryTrack || !cards.length || cards.length !== categories.length) return;

      let selectedBlockIndex = -1;
      let activeIndex = -1;
      let autoPanFrame = 0;
      let hoverFrame = 0;
      let hoverResetTimer = 0;
      let hoverIntentTimer = 0;
      let resetScrollTimer = 0;
      let mobileSyncFrame = 0;
      let hoverLockedUntil = 0;
      let hoverBounds = null;
      let pendingHoverTarget = null;
      let pendingHoverIndex = -1;
      let pendingHoverX = 0;
      let dragPointerId = null;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let isDragging = false;
      let didDrag = false;
      let suppressClick = false;

      const updateHoverBounds = () => {
        const rect = track.getBoundingClientRect();
        hoverBounds = { left: rect.left, width: rect.width };
      };

      const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(updateHoverBounds) : null;
      if (resizeObserver) resizeObserver.observe(track);
      updateHoverBounds();

      function getTransitionDuration() {
        const value = window.getComputedStyle(root).getPropertyValue('--dtc-product-showcase-hover-duration');
        const duration = Number.parseFloat(value);
        return Number.isFinite(duration) ? duration : 300;
      }

      function syncCategoryTrack() {
        const trackRange = Math.max(track.scrollWidth - track.clientWidth, 0);
        const categoryRange = Math.max(categoryTrack.scrollWidth - categoryTrack.clientWidth, 0);
        const progress = trackRange > 0 ? track.scrollLeft / trackRange : 0;
        categoryTrack.scrollLeft = progress * categoryRange;
      }

      function syncMobileNavigation() {
        const trackRect = track.getBoundingClientRect();
        const visibleCards = [];

        categoryTrack.scrollLeft = track.scrollLeft;

        cards.forEach((card, cardIndex) => {
          const cardRect = card.getBoundingClientRect();
          if (cardRect.left >= trackRect.left - 1 && cardRect.right <= trackRect.right + 1) {
            visibleCards.push(cardIndex);
          }
        });

        let index = visibleCards[0];
        if (typeof index !== 'number') {
          let closestDistance = Number.POSITIVE_INFINITY;
          index = 0;

          cards.forEach((card, cardIndex) => {
            const distance = Math.abs(card.getBoundingClientRect().left - trackRect.left);
            if (distance < closestDistance) {
              closestDistance = distance;
              index = cardIndex;
            }
          });
        }

        categories.forEach((category, categoryIndex) => {
          category.classList.toggle('is-active', categoryIndex === index);
        });

        mobileSyncFrame = 0;
      }

      function getClosestVisibleCardIndex() {
        const trackRect = track.getBoundingClientRect();
        let closestDistance = Number.POSITIVE_INFINITY;
        let closestIndex = 0;

        cards.forEach((card, cardIndex) => {
          const cardRect = card.getBoundingClientRect();
          const visibleLeft = Math.max(cardRect.left, trackRect.left);
          const visibleRight = Math.min(cardRect.right, trackRect.right);
          const visibleWidth = Math.max(visibleRight - visibleLeft, 0);
          const cardCenter = cardRect.left + cardRect.width / 2;
          const trackCenter = trackRect.left + trackRect.width / 2;
          const distance = visibleWidth > 0 ? Math.abs(cardCenter - trackCenter) : Number.POSITIVE_INFINITY;

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = cardIndex;
          }
        });

        return closestIndex;
      }

      function stopAutoPan() {
        if (autoPanFrame) {
          window.cancelAnimationFrame(autoPanFrame);
          autoPanFrame = 0;
        }
      }

      function keepCardInView(index) {
        if (!desktopSlider.matches) return;

        stopAutoPan();
        const duration = reducedMotion.matches ? 0 : getTransitionDuration();
        const startedAt = window.performance.now();
        hoverLockedUntil = startedAt + duration + 50;

        const followExpandedCard = (now) => {
          const card = cards[index];
          if (!card || activeIndex !== index || isDragging) {
            autoPanFrame = 0;
            return;
          }

          const trackRect = track.getBoundingClientRect();
          const cardRect = card.getBoundingClientRect();
          let nextScrollLeft = track.scrollLeft;

          if (cardRect.right > trackRect.right) {
            nextScrollLeft += cardRect.right - trackRect.right;
          } else if (cardRect.left < trackRect.left) {
            nextScrollLeft -= trackRect.left - cardRect.left;
          }

          const maxScrollLeft = Math.max(track.scrollWidth - track.clientWidth, 0);
          const clampedScrollLeft = Math.min(Math.max(nextScrollLeft, 0), maxScrollLeft);
          if (Math.abs(clampedScrollLeft - track.scrollLeft) > 0.5) {
            track.scrollLeft = clampedScrollLeft;
            syncCategoryTrack();
          }

          if (now - startedAt < duration + 50) {
            autoPanFrame = window.requestAnimationFrame(followExpandedCard);
          } else {
            autoPanFrame = 0;
          }
        };

        autoPanFrame = window.requestAnimationFrame(followExpandedCard);
      }

      function resetTrackPosition() {
        stopAutoPan();
        const behavior = reducedMotion.matches || !desktopSlider.matches ? 'auto' : 'smooth';
        track.scrollTo({ left: 0, behavior });
        categoryTrack.scrollTo({ left: 0, behavior });
      }

      function setExpanded(index) {
        if (index < 0 || index >= cards.length || index === activeIndex) return;

        window.clearTimeout(hoverIntentTimer);
        window.clearTimeout(resetScrollTimer);
        pendingHoverIndex = -1;
        activeIndex = index;
        hoverLockedUntil = window.performance.now() + getTransitionDuration() + 50;
        root.classList.add('has-expanded-card');
        cards.forEach((card, cardIndex) => {
          const isExpanded = cardIndex === index;
          if (isExpanded) {
            const mediaTemplate = card.querySelector('[data-dtc-expanded-media-template]');
            if (mediaTemplate) mediaTemplate.replaceWith(mediaTemplate.content.cloneNode(true));
          }
          card.classList.toggle('is-expanded', isExpanded);

          const expandedContent = card.querySelector('[data-dtc-product-expanded]');
          if (expandedContent) {
            expandedContent.setAttribute('aria-hidden', String(!isExpanded));
          }
        });
        categories.forEach((category, categoryIndex) => {
          category.classList.toggle('is-active', categoryIndex === index);
        });
        keepCardInView(index);
      }

      function requestExpanded(index) {
        if (
          index < 0 ||
          index >= cards.length ||
          index === activeIndex ||
          index === pendingHoverIndex
        ) {
          return;
        }

        pendingHoverIndex = index;
        window.clearTimeout(hoverIntentTimer);
        hoverIntentTimer = window.setTimeout(() => {
          const nextIndex = pendingHoverIndex;
          pendingHoverIndex = -1;

          if (
            nextIndex >= 0 &&
            desktopHover.matches &&
            !isDragging &&
            selectedBlockIndex < 0
          ) {
            setExpanded(nextIndex);
          }
        }, 80);
      }

      function resetExpanded() {
        window.clearTimeout(hoverIntentTimer);
        window.clearTimeout(resetScrollTimer);
        pendingHoverIndex = -1;
        activeIndex = -1;
        stopAutoPan();
        root.classList.remove('has-expanded-card');
        cards.forEach((card) => {
          card.classList.remove('is-expanded');

          const expandedContent = card.querySelector('[data-dtc-product-expanded]');
          if (expandedContent) {
            expandedContent.setAttribute('aria-hidden', 'true');
          }
        });
        const resetIndex = desktopSlider.matches && sliderEnabled ? getClosestVisibleCardIndex() : 0;
        categories.forEach((category, categoryIndex) => {
          category.classList.toggle('is-active', categoryIndex === resetIndex);
        });
        if (!sliderEnabled && desktopSlider.matches) {
          const duration = reducedMotion.matches ? 0 : getTransitionDuration();
          resetScrollTimer = window.setTimeout(() => {
            track.scrollTo({
              left: 0,
              behavior: reducedMotion.matches ? 'auto' : 'smooth'
            });
            categoryTrack.scrollTo({
              left: 0,
              behavior: reducedMotion.matches ? 'auto' : 'smooth'
            });
          }, duration);
        } else if (!desktopSlider.matches) {
          resetTrackPosition();
        }
      }

      const handleTrackLeave = () => {
        pendingHoverTarget = null;
        pendingHoverIndex = -1;
        window.clearTimeout(hoverIntentTimer);
        if (hoverFrame) {
          window.cancelAnimationFrame(hoverFrame);
          hoverFrame = 0;
        }
        window.clearTimeout(hoverResetTimer);
        hoverResetTimer = window.setTimeout(() => {
          if (selectedBlockIndex < 0 && dragPointerId === null) resetExpanded();
        }, 120);
      };
      const handleTrackEnter = () => {
        window.clearTimeout(hoverResetTimer);
        updateHoverBounds();
      };
      const processHoverPosition = () => {
        hoverFrame = 0;
        if (
          !desktopHover.matches ||
          selectedBlockIndex >= 0 ||
          isDragging ||
          !hoverBounds ||
          hoverBounds.width <= 0 ||
          window.performance.now() < hoverLockedUntil
        ) {
          return;
        }

        const targetCard = pendingHoverTarget ? pendingHoverTarget.closest('[data-dtc-product-card]') : null;
        if (targetCard && targetCard.classList.contains('is-expanded')) return;

        const targetIndex = targetCard ? cards.indexOf(targetCard) : -1;
        if (targetIndex >= 0) {
          requestExpanded(targetIndex);
          return;
        }

        const localX = Math.min(Math.max(pendingHoverX - hoverBounds.left, 0), hoverBounds.width - 1);
        const nextIndex = Math.min(Math.floor((localX / hoverBounds.width) * cards.length), cards.length - 1);
        requestExpanded(nextIndex);
      };
      const handleViewportChange = (event) => {
        if (!event.matches && selectedBlockIndex < 0) resetExpanded();
      };
      const handleTrackScroll = () => {
        if (desktopSlider.matches && (sliderEnabled || root.classList.contains('has-expanded-card'))) {
          syncCategoryTrack();
          return;
        }

        if (mobileSlider.matches && !mobileSyncFrame) {
          mobileSyncFrame = window.requestAnimationFrame(syncMobileNavigation);
        }
      };
      const handleTrackWheel = (event) => {
        if (!sliderEnabled || !desktopSlider.matches) return;
        if (event.deltaX === 0 && !event.shiftKey) return;
        stopAutoPan();
        hoverLockedUntil = window.performance.now() + 100;
      };
      const handleNativeDragStart = (event) => {
        if (!sliderEnabled || !desktopSlider.matches) return;
        event.preventDefault();
      };
      const handlePointerDown = (event) => {
        if (
          !sliderEnabled ||
          !desktopSlider.matches ||
          event.pointerType !== 'mouse' ||
          event.button !== 0 ||
          event.target.closest('a, button')
        ) {
          return;
        }

        stopAutoPan();
        dragPointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScrollLeft = track.scrollLeft;
        didDrag = false;
        track.setPointerCapture(event.pointerId);
      };
      const handlePointerMove = (event) => {
        if (event.pointerId !== dragPointerId) {
          pendingHoverTarget = event.target;
          pendingHoverX = event.clientX;
          window.clearTimeout(hoverResetTimer);
          if (!hoverFrame) hoverFrame = window.requestAnimationFrame(processHoverPosition);
          return;
        }

        const distance = event.clientX - dragStartX;
        if (!isDragging && Math.abs(distance) < 5) return;

        isDragging = true;
        didDrag = true;
        root.classList.add('is-dragging');
        track.scrollLeft = dragStartScrollLeft - distance;
        syncCategoryTrack();
        event.preventDefault();
      };
      const finishPointerDrag = (event) => {
        if (event.pointerId !== dragPointerId) return;

        if (track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }

        dragPointerId = null;
        isDragging = false;
        root.classList.remove('is-dragging');
        hoverLockedUntil = window.performance.now() + 100;

        if (didDrag) {
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 0);
        }

        const trackRect = track.getBoundingClientRect();
        const pointerOutside =
          event.clientX < trackRect.left ||
          event.clientX > trackRect.right ||
          event.clientY < trackRect.top ||
          event.clientY > trackRect.bottom;

        if (pointerOutside && selectedBlockIndex < 0) resetExpanded();
      };
      const handleTrackClick = (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      };
      const handleTrackKeydown = (event) => {
        if (!sliderEnabled || !desktopSlider.matches) return;
        if (event.key === 'Escape') {
          if (selectedBlockIndex < 0) resetExpanded();
          return;
        }
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const currentIndex = activeIndex >= 0 ? activeIndex : 0;
        const nextIndex = Math.min(Math.max(currentIndex + direction, 0), cards.length - 1);
        setExpanded(nextIndex);
      };

      track.addEventListener('pointerenter', handleTrackEnter);
      track.addEventListener('pointerleave', handleTrackLeave);
      track.addEventListener('scroll', handleTrackScroll, { passive: true });
      track.addEventListener('wheel', handleTrackWheel, { passive: true });
      track.addEventListener('dragstart', handleNativeDragStart);
      track.addEventListener('pointerdown', handlePointerDown);
      track.addEventListener('pointermove', handlePointerMove);
      track.addEventListener('pointerup', finishPointerDrag);
      track.addEventListener('pointercancel', finishPointerDrag);
      track.addEventListener('click', handleTrackClick, true);
      track.addEventListener('keydown', handleTrackKeydown);
      desktopHover.addEventListener('change', handleViewportChange);
      desktopSlider.addEventListener('change', handleViewportChange);

      const instance = {
        selectBlock(blockId) {
          const index = cards.findIndex((card) => card.dataset.blockId === blockId);
          if (index < 0) return;
          selectedBlockIndex = index;
          setExpanded(index);
        },
        deselectBlock(blockId) {
          const card = cards[selectedBlockIndex];
          if (!card || card.dataset.blockId !== blockId) return;
          selectedBlockIndex = -1;
          resetExpanded();
        },
        cleanup() {
          stopAutoPan();
          window.clearTimeout(hoverResetTimer);
          window.clearTimeout(hoverIntentTimer);
          window.clearTimeout(resetScrollTimer);
          if (hoverFrame) window.cancelAnimationFrame(hoverFrame);
          if (mobileSyncFrame) window.cancelAnimationFrame(mobileSyncFrame);
          if (resizeObserver) resizeObserver.disconnect();
          track.removeEventListener('pointerenter', handleTrackEnter);
          track.removeEventListener('pointerleave', handleTrackLeave);
          track.removeEventListener('scroll', handleTrackScroll);
          track.removeEventListener('wheel', handleTrackWheel);
          track.removeEventListener('dragstart', handleNativeDragStart);
          track.removeEventListener('pointerdown', handlePointerDown);
          track.removeEventListener('pointermove', handlePointerMove);
          track.removeEventListener('pointerup', finishPointerDrag);
          track.removeEventListener('pointercancel', finishPointerDrag);
          track.removeEventListener('click', handleTrackClick, true);
          track.removeEventListener('keydown', handleTrackKeydown);
          desktopHover.removeEventListener('change', handleViewportChange);
          desktopSlider.removeEventListener('change', handleViewportChange);
          instances.delete(root);
        }
      };

      instances.set(root, instance);
    }

    function initializeWhenNearViewport(root) {
      if (!root || instances.has(root)) return;
      if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) {
        initializeProductShowcase(root);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        initializeProductShowcase(root);
      }, { rootMargin: '400px 0px' });

      observer.observe(root);
      root.addEventListener('focusin', () => {
        observer.disconnect();
        initializeProductShowcase(root);
      }, { once: true });
    }

    function initializeAll() {
      document.querySelectorAll(rootSelector).forEach(initializeWhenNearViewport);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeProductShowcase(findRoot(event.target));
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = findRoot(event.target);
      const instance = root ? instances.get(root) : null;
      if (instance) instance.cleanup();
    });

    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest ? event.target.closest(rootSelector) : null;
      if (!root) return;
      initializeProductShowcase(root);

      const instance = instances.get(root);
      const card = event.target.closest('[data-dtc-product-card]');
      if (instance && card) instance.selectBlock(card.dataset.blockId);
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const root = event.target.closest ? event.target.closest(rootSelector) : null;
      const instance = root ? instances.get(root) : null;
      const card = event.target.closest ? event.target.closest('[data-dtc-product-card]') : null;
      if (instance && card) instance.deselectBlock(card.dataset.blockId);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-inside-do-more"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('dtc-inside-reveal')) return;

    class DtcInsideReveal extends HTMLElement {
      constructor() {
        super();
        this.animations = [];
        this.observer = null;
        this.initialized = false;
        this.hasPlayed = false;
        this.handleMotionChange = () => this.syncMotion();
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        if (
          this.dataset.revealEnabled === 'false' ||
          !('IntersectionObserver' in window) ||
          typeof Element.prototype.animate !== 'function'
        ) return;

        this.section = this.closest('[data-dtc-inside-do-more]');
        if (!this.section) return;

        try {
          const readSetting = (key, fallback) => {
            const value = Number.parseInt(this.dataset[key], 10);
            return Number.isFinite(value) ? Math.max(0, value) : fallback;
          };

          this.duration = Math.max(1, readSetting('revealDuration', 300));
          this.stagger = readSetting('revealStagger', 20);
          this.delay = readSetting('revealDelay', 200);
          this.groups = this.buildGroups();
          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.motionQuery.addEventListener('change', this.handleMotionChange);
          this.syncMotion();
        } catch {
          this.stopMotion();
          this.motionQuery?.removeEventListener('change', this.handleMotionChange);
        }
      }

      buildGroups() {
        const segmenter = window.Intl?.Segmenter
          ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
          : null;

        return Array.from(this.querySelectorAll('[data-dtc-reveal-group]'), (group) => {
          const characters = [];

          group.querySelectorAll('[data-dtc-reveal-text]').forEach((text) => {
            const parts = segmenter
              ? Array.from(segmenter.segment(text.textContent), (part) => part.segment)
              : Array.from(text.textContent);
            const fragment = document.createDocumentFragment();

            parts.forEach((part) => {
              if (/^\s+$/u.test(part)) {
                fragment.appendChild(document.createTextNode(part));
                return;
              }

              const character = document.createElement('span');
              character.className = 'dtc-inside-do-more__character';
              character.textContent = part;
              fragment.appendChild(character);
              characters.push(character);
            });

            text.replaceChildren(fragment);
          });

          return characters;
        });
      }

      resetReveal() {
        this.animations.forEach((animation) => animation.cancel());
        this.animations = [];
        this.hasPlayed = false;
      }

      playReveal() {
        if (this.hasPlayed) return;
        this.hasPlayed = true;

        try {
          this.groups.forEach((characters) => {
            const shuffled = [...characters];

            for (let index = shuffled.length - 1; index > 0; index -= 1) {
              const randomIndex = Math.floor(Math.random() * (index + 1));
              [shuffled[index], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[index]];
            }

            shuffled.forEach((character, index) => {
              this.animations.push(character.animate(
                [{ opacity: 0 }, { opacity: 1 }],
                {
                  duration: this.duration,
                  delay: this.delay + index * this.stagger,
                  easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
                  fill: 'both'
                }
              ));
            });
          });
        } catch {
          this.stopMotion();
        }
      }

      syncMotion() {
        this.stopMotion();
        if (this.motionQuery.matches || !this.isConnected) return;

        try {
          const trigger = this.querySelector('[data-dtc-reveal-trigger]') || this;
          this.sectionInView = false;

          this.observer = new IntersectionObserver((entries) => {
            let triggerEntry = null;

            entries.forEach((entry) => {
              if (entry.target === this.section) {
                this.sectionInView = entry.isIntersecting;
                if (!this.sectionInView) this.resetReveal();
              }

              if (entry.target === trigger) triggerEntry = entry;
            });

            if (this.sectionInView && triggerEntry && triggerEntry.intersectionRatio >= 0.4) {
              this.playReveal();
            }
          }, { threshold: [0, 0.4] });

          this.classList.add('is-reveal-ready');
          this.observer.observe(this.section);
          this.observer.observe(trigger);
        } catch {
          this.stopMotion();
        }
      }

      stopMotion() {
        this.observer?.disconnect();
        this.observer = null;
        this.resetReveal();
        this.classList.remove('is-reveal-ready');
      }

      disconnectedCallback() {
        this.motionQuery?.removeEventListener('change', this.handleMotionChange);
        this.stopMotion();
        this.initialized = false;
      }
    }

    customElements.define('dtc-inside-reveal', DtcInsideReveal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      // this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wonder-qa"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.wonder-qa').forEach((section) => {
    if (section.dataset.accordionInitialized === 'true') return;

    section.dataset.accordionInitialized = 'true';
    const items = section.querySelectorAll('.wonder-qa__item');

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.removeAttribute('open');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
